/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, DateRange, Highcharts, mp */

// For inheriting you'll need to implement get_display_models, get_release_models, get_visible_models, get_query_name
// and set:
//   slug, nice_name, description
//
_.namespace(`mp.marketing.trends.widgets`, function(ns) {
  'use strict';
  var TimeRangeViewer = mp.marketing.trends.TimeRangeViewer;

  var UNKNOWN = `UNKNOWN`;

  ns.PhoneAdoption = mp.marketing.trends.widgets.TrendReport.extend({
    get_defaults() {
      var first_release = this.get_release_models()[0].release_date;
      var start_date = new Date(first_release.getFullYear(), first_release.getMonth(), 1);
      var end_date = new Date(start_date).add(365).days();
      var today = new Date();
      if (today < end_date) {
        end_date = today;
      }
      var range = new DateRange(start_date, end_date);
      return {
        date_range: range,
        report_unit: range.days() > 30 ? `week` : `day`,
      };
    },

    get_query_name() {
      throw new Error(`UNIMPLEMENTED`);
    },

    get_queries() {
      var unit = this.session.get(`report_unit`);
      var date_range = this.session.get(`date_range`);

      return {
        base: {
          'from_date': date_range.from().toString(mp.utility.default_date_format),
          'query_name': this.get_query_name(),
          'to_date': date_range.to().toString(mp.utility.default_date_format),
          unit,
        },
      };
    },

    // Return all models (including "other") in their display order
    get_display_models() {
      throw new Error(`UNIMPLEMENTED`);
    },

    // Returns the models that are the focus of the report
    get_release_models() {
      throw new Error(`UNIMPLEMENTED`);
    },

    // Returns the models whose segments are enabled by default in the report
    get_visible_models() {
      throw new Error(`UNIMPLEMENTED`);
    },

    _phone_model_name(model_id) {
      var ret = UNKNOWN;
      for (const model of this.get_display_models()) {
        if (model_id.match(model.regex)) {
          ret = model.name;
          break;
        }
      }
      return ret;
    },

    get_release_dates() {
      var ret = [];
      // Keep track of dates, only display the first
      // model released on a given date.
      var dates = [];
      for (const model of this.get_release_models()) {
        var date_string = model.release_date.toISOString();
        if (!dates.includes(date_string)) {
          ret.push({
            text: _.sprintf(`%s Release`, model.name),
            value: model.release_date,
          });
          dates.push(date_string);
        }
      }
      return ret;
    },

    get_chart_params(query_data) {
      delete query_data.base.Unknown;

      var parse_date = function(date_string) {
        var date = Date.parseExact(date_string, `yyyy-MM-dd HH:mm:ss`) ||
                       Date.parseExact(date_string, `yyyy-MM-dd`);
        // dates from arb are in PST (project time)
        date.setTimezone(`PST`);
        return date;
      };

      var models_to_series = _.groupBy(query_data.base, (_, model_id) => {
        return this._phone_model_name(model_id);
      });
      _.each(this.get_display_models(), function(model) {
        if (!_.has(models_to_series, model.name)) {
          models_to_series[model.name] = [];
        }
      });
      delete models_to_series[UNKNOWN];

      var models_to_one_series = {};
      var totals = {};
      _.each(models_to_series, function(model_series, model_name) {
        var this_model = {};

        _.each(model_series, function(series) {
          _.each(series, function(value, date) {
            if (parse_date(date).getTime() < mp.report.globals.utc_now) {
              if (_.isUndefined(this_model[date])) {
                this_model[date] = 0;
              }
              if (_.isUndefined(totals[date])) {
                totals[date] = 0;
              }
              this_model[date] += value;
              totals[date] += value;
            }
          });
        });
        models_to_one_series[model_name] = this_model;
      });

      var chart_data = _.chain(models_to_one_series)
        .pairs()
        .sortBy(function(model_series_pair) {
          return _.map(this.get_display_models(), function(model) {
            return model.name;
          }).indexOf(model_series_pair[0]);
        }, this)
        .map(function(model_series_pair, i) {
          var model = model_series_pair[0],
            series = model_series_pair[1];

          return {
            name: model,
            color: mp.charts.nth_color(i, this.color_scheme),
            data: _.map(series, function(val, date) {
              var unixtime = parse_date(date).getTime();
              var percent = 0;
              if (totals[date]) {
                percent = (val / totals[date]) * 100;
              }
              return [unixtime, percent];
            }).sort(),
            visible: _.contains(_.pluck(this.get_visible_models(), `name`), model),
          };
        }, this)
        .value();

      var xaxis_config;
      if (this.session.get(`report_unit`) === `hour`) {
        xaxis_config = {
          'type': `datetime`,
          'tickInterval': 4 * 60 * 60 * 1000, // 4 hrs
          'labels': {
            'formatter'() {
              return Highcharts.dateFormat(`%b. %e, %l %p`, this.value);
            },
            'rotation': -45,
          },
        };
      } else {
        xaxis_config = {
          'type': `datetime`,
          'minTickInterval': 24 * 60 * 60 * 1000, // 24 hrs
          'labels': {
            'formatter'() {
              return Highcharts.dateFormat(`%b. %e`, this.value);
            },
          },
        };
      }

      var color_idx = chart_data.length - 1;
      xaxis_config.plotLines = _.map(this.get_release_dates(), function(release_date) {
        color_idx++;
        return {
          value: release_date.value,
          color: mp.charts.nth_color(color_idx, this.color_scheme),
          width: 1,
          zIndex: 2,
          label: {
            text: release_date.text,
            verticalAlign: `middle`,
            textAlign: `center`,
          },
        };
      }, this);

      return {
        'xAxis': xaxis_config,
        'yAxis': {'labels': {'formatter'() { return this.value + `%`; }}},
        'series': chart_data,
        'tooltip': {
          'backgroundColor': `rgba(255, 255, 255, 1)`,
          'borderWidth': 1,
          'crosshairs': true,
          'pointFormat': `<span style="color:{series.color}">{series.name}</span>: <b>{point.y}%</b><br/>`,
          'shared': true,
          'useHTML': false,
          'valueDecimals': 2,
        },
        'chart': {'marginBottom': 120},
        'legend': {
          'align': `bottom`,
          'x': 100
        },
      };
    },
  });

  Object.assign(ns.PhoneAdoption, {
    chart_type: `line`,
    color_scheme: `vibrant`,
    asterisk: `Time/Date in UTC`,
    view_class: TimeRangeViewer,
    time_units: [`day`, `week`, `month`],
  });
});

}.call(window));